<template>
  <div>
    <div class="tui-tableTitle">平均每人每日食材消耗量</div>
    <el-card>
      <div v-for="(item, index) in tableData" :key="index">
        <div class="tui-tableTitle">{{ item.BigTypeName }}</div>
        <el-table
          :data="item.TypeDetails"
          style="width: 100%"
          :header-cell-style="{
            background: '#F2F5FF',
            color: '#333',
            'text-align': 'center',
          }"
          border
        >
          <el-table-column
            label="食品类别"
            prop="TypeName"
            align="center"
          ></el-table-column>
          <el-table-column prop="Weight" label="本月总量(斤)" align="center">
          </el-table-column>
          
          <el-table-column
            v-if="item.Recommend"
            label="推荐摄入量"
            prop="Recommend"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="EveryOneUsed"
            label="人均消耗量(g)"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [],
      value: "",

      PageSize: 10,
      PageIndex: 1,
      total: 0,
    };
  },
  created() {},
  props: {
    tableData: Array,
  },
  methods: {
    onClickCurrent(index) {
      this.currentIndex = index;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-box {
  width: 382px;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}
.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>